import {action, observable, runInAction} from 'mobx';
import GenericFormStore from '../../stores/FormStore';
import userStore from '../../stores/UserStore';
import {actions, category, events} from '../../constants/enums';
import {customEvent} from '../../utils/analyticsUtil';
import {go} from '../../utils/navigationUtility';

class SigninStore extends GenericFormStore {
    @observable isAuthenticating = false;
    @observable form = this._init();

    _init = () => {
        return {
            fields: {
                email: {
                    value: '',
                    error: '',
                    rule: 'required|email'
                },
                password: {
                    value: '',
                    error: '',
                    rule: 'required|password'
                },
            },
            meta: {
                isValid: true,
                error: null,
            },
        };
    };

    /**
     * Checks for abnormalities in the form before submitting to the server
     */
    _validateBeforeReq() {
        const {email, password} = this.form.fields;
        if (!email.value || !password.value || email.error || password.error) {
            this.form.meta.error = 'Please fill all the fields correctly';
            this._clearMetaError();
            return false;
        }

        return true;
    }

    _clearMetaError = () => {
        setTimeout(() => {
            runInAction(() => {
                this.form.meta.error = '';
            });
        }, 3500);
    };

    @action login = async (hasRedirect = true) => {
        if (!this._validateBeforeReq()) {
            return;
        }

        const {fields} = this.form;
        this.isAuthenticating = true;
        customEvent(events.CustomEvent, {category: category.Login, action: actions.Click, label: 'Internal'});
        try {
            await userStore.login(fields.email.value, fields.password.value);
            runInAction(() => {
                this.isAuthenticating = false;
                this.form = this._init();
                if (hasRedirect) {
                    go('/');
                }
            });
        } catch (err) {
            runInAction(() => {
                console.log(err);
                if (err) {
                    switch (err.code) {
                        case 'UserLambdaValidationException':
                            try {
                                const errorDetails = JSON.parse('{' + err.message.split('{')[1].slice(0, -1));
                                if (errorDetails.provider === 'Cognito') {
                                    this.form.meta.error = 'This email is already in use.<br/>Please go to the log-in page.';
                                } else {
                                    this.form.meta.error = `This email was already used to register using ${errorDetails.provider}, please login with your ${errorDetails.provider} account`;
                                }
                            } catch (err) {
                                this.form.meta.error = err.message;
                            }
                            break;
                        case 'NotAuthorizedException' :
                            let error = 'Something went wrong, please try again.';
                            if (err.message === 'Temporary password has expired and must be reset by an administrator.') {
                                error = 'Your temporary password has expired. Please contact teacher to restore your login info.'
                            } else if (err.message === 'Incorrect username or password.') {
                                error = err.message;
                            } else if (err.message === 'Password attempts exceeded') {
                                error = 'Password attempts exceeded, please use forgot password link' ;
                            } else if (err.message === 'User is disabled.') {
                                error = 'There\'s a problem with your account. Please contact info@musico.io for more details.';
                            }
                            console.log('Auth failed with: ' + err.message);
                            this.form.meta.error = error;
                            break;
                        default:
                            this.form.meta.error = err && err.message ? err.message : err;
                    }
                }
                this.isAuthenticating = false;
            });
        }
    };

    @action completeNewPasswordChallenge = async (newPassword) => {
        const {fields} = this.form;
        this.isAuthenticating = true;
        try {
            await userStore.completeNewPasswordChallenge(fields.email.value, newPassword);
            runInAction(() => {
                this.isAuthenticating = false;
                this.form = this._init();
                go('/');
            });
        } catch (err) {
            runInAction(() => {
                this.form.meta.error = err && err.message ? err.message : '';
                this.isAuthenticating = false;
            });
        }
    }
}

const signinStore = new SigninStore();
export default signinStore;
